import { render } from "./OuterMetadataInput.vue?vue&type=template&id=23a5be9f&scoped=true&ts=true"
import script from "./OuterMetadataInput.vue?vue&type=script&lang=ts"
export * from "./OuterMetadataInput.vue?vue&type=script&lang=ts"

import "./OuterMetadataInput.vue?vue&type=style&index=0&id=23a5be9f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a5be9f"]])

export default __exports__